import {getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";

@Module({dynamic: true, store, name: 'store_scanforacceptpacket'})
export class StoreCommon extends VuexModule {
  public orderInfoList = [];
  @Mutation
  public SetOrderInfoList(state) {
    this.orderInfoList = state;
  }
}
export const store_commonModule = getModule(StoreCommon)
